export enum QueryParamKeys {
  Entrypoint = 'entrypoint',
  OrderId = 'orderId',
  DealerPublicId = 'dealerPublicId',
  Pdi = 'pdi',
  HybridToken = 'hybridToken',
  OobaToken = 'oobaToken',
  ContractToken = 'contractToken',
  LaunchPage = 'launchPage',
  ReviewPage = 'reviewPage',
  ContractSummaryPage = 'contractSummaryPage',
  MerchantContractSummaryPage = 'merchantContractSummaryPage',
  Referrer = 'referrer',
  AppStatus = 'appStatus',
  ParentDomain = 'parentDomain',
  EntrypointSessionId = 'entrypointSessionId',
  CampaignMedium = 'cm',
  CampaignSource = 'cs',
  UtmId = 'utm_id',
  UtmSource = 'utm_source',
  UtmMedium = 'utm_medium',
  UtmCampaign = 'utm_campaign',
  UtmTerm = 'utm_term',
  UtmContent = 'utm_content',
  Gclid = 'gclid',
  Fbclid = 'fbclid',
  Msclkid = 'msclkid',
  LiFatId = 'li_fat_id',
  Ttclid = 'ttclid',
  Language = 'language',
}

export enum EntrypointValues {
  MobileEmbedded = 'mobile_embedded',
  Copy = 'copy',
  VirtualCardEmail = 'virtual_card_email',
}
